import gql from 'graphql-tag';

export const GET_OFFER_DETAILS = gql`
  query ($applicationId: String!) {
    offer(applicationId: $applicationId) {
      applicationId
      applicationNo
      applicantName
      applicantChineseName
      applicantNationality
      refNo
      offerDate
      entryYear
      department
      programme
      programmeType
      programmeCode
      programmeSubcode
      studyMode
      normalPeriodOfStudy
      creditRequirement
      reportingDutyDate
      commencementDate
      entryYearDisplayName
      supervisor
      researchArea
      acceptDeadline
      isFirmOffer
      conditions {
        item
        title
        detail
        file {
          id
          link
          name
        }
        remark
        passed
        checkedBy
        checkedAt
      }
      conditionFulfilled
      conditionFulfillingDeadline
      fundingLetter {
        id
        name
        link
      }
      status
    }

    studentParticular(applicationId: $applicationId) {
      offeredToSemester
    }

    programmeChoiceMetadata {
      departmentList {
        value
        label
      }
    }
  }
`;
